import type { MaybeRefOrGetter } from 'vue';
import type { GlobalPrimitiveFieldId } from '#layers/data-model/types/schema/ids';
import { computed, toValue } from 'vue';
import { useWorkspaceSchemaStore } from '#layers/data-model/stores/workspace-schema';

export function usePrimitiveField(fieldId: MaybeRefOrGetter<GlobalPrimitiveFieldId | null | undefined>) {
	const { findPrimitiveFieldById } = useWorkspaceSchemaStore();
	return computed(() => {
		const fieldIdValue = toValue(fieldId);
		return fieldIdValue ? findPrimitiveFieldById(fieldIdValue) : undefined;
	});
}
